import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KdBuildVersionService extends ReplaySubject<string> {
  constructor() {
    super(1);
  }
}
